import * as React from 'react';

import {
  Lang,
  Breakpoint,

  useDimensions,
} from '@bluecurrent/web-component-lib';

import SegmentedControls from '../../../../SegmentedControls';

export default function Controls({
  width,
  type,
  chart,
  onSelectElectricity,
  onSelectGas,
  onSelectChart,
}) {
  const { _ } = Lang.useTranslation();
  const size = useDimensions();

  return (
    <div
      style={{
        width,
        height: 'auto',
        display: 'flex',
        flexDirection: size.width < Breakpoint.xs ? 'column' : 'row',
        alignItems: size.width < Breakpoint.xs ? 'flex-end' : 'center',
        justifyContent: 'space-between',
        gap: 5,
      }}
    >
      <SegmentedControls
        items={[
          {
            id: 0,
            text: _('electricity', { ns: 'ui' }),
            isActive: type === 'electricity',
            onClick: () => onSelectElectricity(),
          },
          {
            id: 1,
            text: _('gas', { ns: 'ui' }),
            isActive: type === 'gas',
            onClick: () => onSelectGas(),
          },
        ]}
      />
      <SegmentedControls
        items={[
          {
            id: 0,
            text: `${_('marketPrice', { ns: 'ui' })} ¹`,
            isActive: chart === 'market',
            onClick: () => onSelectChart('market'),
          },
          {
            id: 1,
            text: `${_('allInPrice', { ns: 'ui' })} ²`,
            isActive: chart === 'all-in',
            onClick: () => {
              onSelectChart('all-in');
            },
          },
        ]}
      />
    </div>
  );
}
